import { inject, Service } from '@angular/core';
import { WINDOW } from '@portal-core/util/window.provider';

/**
 * Removes old auth data from local storage.
 */
@Service()
export class AuthLocalStorageCleanupService {
  private readonly window = inject<Window>(WINDOW);

  constructor() {
    this.window.localStorage.removeItem('authState');
    this.window.localStorage.removeItem('authState.auth');
    this.window.localStorage.removeItem('authState.lastActivatedRoute');
  }
}
